export default (theme) => ({
  videoControls: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    visibility: 'hidden',
    opacity: 0,
    transition: 'opacity .3s linear',
  },
  controlButtons: {
    position: 'absolute',
    bottom: 45,
    display: 'flex',
    width: '100%',
    height: 60,
    left: '50%',
    transform: 'translateX(-50%)',
    justifyContent: 'center',
    zIndex: 100,
  },
  videoControlsActive: {
    visibility: 'visible',
    opacity: 1,
  },
  controlButton: {
    margin: '0 10px',
    borderRadius: '50%',
    border: 'none',
    backgroundColor: theme.palette.primary.main,
    cursor: 'pointer',
    width: 58,
    height: 58,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'opacity .3s linear',
    '&:hover': {
      opacity: 0.5,
    },
    '&:disabled': {
      opacity: 0.5,
      pointerEvents: 'none',
    },
    [theme.breakpoints.down('md')]: {
      '&:hover': {
        opacity: 1,
      },
    },
    [theme.breakpoints.down('sm')]: {
      margin: '0 10px',
      width: 46,
      height: 46,
    },
  },
  endCallControlButton: {
    margin: '0 10px',
    borderRadius: '50%',
    border: 'none',
    backgroundColor: '#E03838',
    cursor: 'pointer',
    width: 58,
    height: 58,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'opacity .3s linear',
    '&:hover': {
      opacity: 0.5,
    },
    [theme.breakpoints.down('md')]: {
      '&:hover': {
        opacity: 1,
      },
    },
    [theme.breakpoints.down('sm')]: {
      width: 46,
      height: 46,
      margin: '0 10px',
    },
  },
  inactiveControlButton: {
    backgroundColor: theme.palette.disabled.main,
  },
  icon: {
    fill: theme.palette.background.default,
    maxWidth: 25,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 15,
    },
  },
  fullScreenButton: {
    position: 'absolute',
    top: 14,
    left: 10,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    transition: 'opacity .3s linear',
    '&:hover': {
      opacity: 0.5,
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
});
